var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "",
    height: "",
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 5.67828C31 4.71993 30.619 3.80084 29.9407 3.12318C29.2624 2.44553 28.3425 2.06483 27.3833 2.06483H13.1821C12.8763 2.06581 12.5771 1.97597 12.3225 1.80673L10.5271 0.607195C9.93255 0.209983 9.23311 -0.00139153 8.5179 6.89424e-06H3.61667C2.65747 6.89424e-06 1.73755 0.380708 1.0593 1.05836C0.381041 1.73601 0 2.65511 0 3.61345V6.71069C0 6.84759 0.0544343 6.97889 0.151328 7.0757C0.248222 7.17251 0.379638 7.22689 0.516667 7.22689H30.4833C30.6204 7.22689 30.7518 7.17251 30.8487 7.0757C30.9456 6.97889 31 6.84759 31 6.71069V5.67828Z",
    fill: "#F2BB6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.1645C0 22.1228 0.381041 23.0419 1.0593 23.7196C1.73755 24.3972 2.65747 24.7779 3.61667 24.7779H27.3833C28.3425 24.7779 29.2624 24.3972 29.9407 23.7196C30.619 23.0419 31 22.1228 31 21.1645V9.80795C31 9.67105 30.9456 9.53975 30.8487 9.44294C30.7518 9.34613 30.6204 9.29175 30.4833 9.29175H0.516667C0.379638 9.29175 0.248222 9.34613 0.151328 9.44294C0.0544343 9.53975 0 9.67105 0 9.80795V21.1645Z",
    fill: "#F2BB6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder1);
export default __webpack_public_path__ + "static/media/Folder1.06ea5b36fcd63c5cfe56e5d0c5abd664.svg";
export { ForwardRef as ReactComponent };